<template lang="pug">
.scheduler-option(
  :class="classes"
  @click="onSelect"
  :data-test-id="kebabCaseType"
  )
  .scheduler-icon(:class="`${iconClass}`")
    BriqIcon(:name="iconClass" :customStyle="iconStyle(type)")
  .text-block
    .title {{ title }}
    .description {{ description }}
</template>

<script>
export default {
  name: 'SchedulerSelector',
  props: {
    title: String,
    description: String,
    selected: Boolean,
    disabled: Boolean,
    size: {
      type: String,
      default: 'large',
    },
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    kebabCaseType() {
      switch (this.type) {
        case 'noDuration':
          return 'no-duration'
        case 'fixedDuration':
          return 'fixed-duration'
        case 'perParticipants':
          return 'per-participants'
        default:
          return this.type
      }
    },
    classes() {
      return {
        selected: this.selected,
        disabled: this.disabled,
        [this.size]: true,
      }
    },
    iconClass() {
      return this.selected
        ? `icon-${this.kebabCaseType}-product-schedule-selected`
        : `icon-${this.kebabCaseType}-product-schedule`
    },
    sizeOfIcon() {
      return this.size === 'large' ? 100 : 60
    },
  },
  methods: {
    onSelect() {
      if (!this.disabled) this.$emit('selected', this.type)
    },
    iconStyle(type) {
      return {
        fontSize: `${this.sizeOfIcon}px`,
        position: 'relative',
        top: `${this.getIconPositioning(type)}px`,
      }
    },
    getIconPositioning(type) {
      switch (type) {
        case 'sequential':
          return -15
        case 'parallel':
          return -22
        case 'noDuration':
          return -13
        case 'fixedDuration':
        case 'perParticipants':
          return -5
      }
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.scheduler-option
  display flex
  border 1px solid grey300
  border-radius 5px
  padding 15px
  width 50%
  margin-right 10px
  cursor pointer
  background-color white

  .scheduler-icon
    background-color grey200
    padding 5px
    border-radius 5px
    height 80px

  .text-block
    color black1
    margin-left 10px
    display flex
    flex-direction column
    justify-content center

    .title
      {typeBold}
      font-weight bold
    .description
      {typeSmall}

.scheduler-option:last-child
  margin-right 0px

.selected
  background-color grey800
  .scheduler-icon
    background-color grey700
  .text-block
    color white

.disabled
  opacity 0.6
  cursor not-allowed

.small
  .scheduler-icon
    height 60px
</style>
